import { preloadQuery } from "@relay";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { usePreloadedQuery } from "react-relay";
import { graphql } from "relay-runtime";
import { CartProvider } from "~/contexts/CartContext";
import { routeHubMetaNameQuery } from "./__generated__/routeHubMetaNameQuery.graphql";

export const hubMetaNameQuery = graphql`
	query routeHubMetaNameQuery($hubMetaName: String!) {
		hubMeta(by: { name: $hubMetaName }) @required(action: THROW) {
			id
			hub @required(action: THROW) {
				id
				products(pagination: { page: 0, pageSize: 1000000 }, filter: { active: true }) {
					nodes {
						id
						...ProductDrawerFragment
					}
				}
			}
			organization {
				id
				supportEmail
			}
			name
			city
			country
			postalCode
			street
			country
		}
	}
`;

export const Route = createFileRoute("/$hubMetaName")({
    beforeLoad: () => {
        document.title = 'bacehub | Startseite'
    },
	component: RouteComponent,
	loader: async (ctx) => {
		return preloadQuery<routeHubMetaNameQuery>(ctx.context.relayEnvironment, hubMetaNameQuery, { hubMetaName: ctx.params.hubMetaName });
	},
});

function RouteComponent() {
	const { hubMeta } = usePreloadedQuery<routeHubMetaNameQuery>(hubMetaNameQuery, Route.useLoaderData());
	return (
		<CartProvider hubId={hubMeta.hub.id}>
			<Outlet />
		</CartProvider>
	);
}
